import {memo} from 'react';

import styled from 'styled-components';

import TenbisCreditIcon from '~/assets/images/icons/tenbisCredit.svg?react';
import TenbisIcon from '~/assets/images/icons/tenbisCard.svg?react';
import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/media';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {body16Bold} from '~/shared/theme/typography';

import {Title} from '../MoneyCardDetails/components/shared.styles';

const TenbisCreditContainer = styled.div`
  margin-top: 32px;
  ${media.minLargeTablet`
    margin-top: 48px;
  `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
`;

const CreditTitle = styled(Title)`
  padding: 0;
  margin: 0;
`;

const Content = styled.div`
  padding: 20px 16px;
  margin-top: 16px;
  background: ${({theme}) => theme.colors.surface};
  box-shadow: ${({theme}) => theme.shadows.elevationCard};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.minLargeMobile`
    padding: 16px;
  `}
`;

const Balance = styled.span`
  ${body16Bold}
  color: ${({theme}) => theme.colors.contentDefault};
  margin-bottom: 4px;
  ${media.minLargeMobile`
    font-size: 28px;
  `}
`;

const Label = styled.span`
  font-size: 12px;
  color: ${({theme}) => theme.colors.contentSubdued};
  ${media.minLargeMobile`
    font-size: 14px;
  `}
`;

const Icon = styled(TenbisCreditIcon)`
  path {
    fill: ${({theme}) => theme.colors.actionBrand};
  }

  ${flipOnLTR`
    margin-left: 8px;
  `}
`;

const IconTenbis = styled(TenbisIcon)`
  ${flipOnLTR`
    margin-left: 8px;
  `}
`;

const PrepaidCard = memo(
  ({balance, cardSuffix, isTenbisCredit}: {balance: number; cardSuffix: string; isTenbisCredit: boolean}) => {
    const {t} = getLocalizationService();
    return (
      <TenbisCreditContainer>
        <Header>
          {isTenbisCredit ? <Icon /> : <IconTenbis />}
          <CreditTitle>{isTenbisCredit ? t('tenbis_credit') : t('card_number_xxxx', {cardSuffix})}</CreditTitle>
        </Header>
        <Content>
          <Balance>₪{balance.toFixed(2)}</Balance>
          <Label>{t('balance')}</Label>
        </Content>
      </TenbisCreditContainer>
    );
  },
);

export default PrepaidCard;
